module.exports = __webpack_public_path__ + "img/image3.2a9d6964.png";